import { Assessment, TableChart } from "@mui/icons-material";
import { Box, Button, useMediaQuery, useTheme } from "@mui/material";

export default function SelectorTipoAnalisis({
    tipoAnalisisSel,
    onTipoAnalisisChange,
}) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const buttonSx = (isSelected) => ({
        textTransform: "none",
        fontWeight: 600,
        px: { xs: 2, sm: 3 },
        py: { xs: 1.5, sm: 1.5 },
        borderRadius: 2,
        minWidth: { xs: "100%", sm: 180 },
        flex: isMobile ? 1 : "0 0 auto",
        transition: "all 0.2s ease",
        border: isSelected ? "2px solid #3baec7" : "2px solid #e0e0e0",
        bgcolor: isSelected ? "#e0f7fa" : "white",
        color: isSelected ? "#1a8a9e" : "#616161",
        boxShadow: isSelected ? "0 2px 8px rgba(59, 174, 199, 0.25)" : "none",
        "&:hover": {
            bgcolor: isSelected ? "#b2ebf2" : "#f5f5f5",
            borderColor: isSelected ? "#3baec7" : "#80deea",
            transform: isMobile ? "none" : "translateY(-1px)",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
        },
        "&:active": {
            transform: "scale(0.98)",
        },
        "& .MuiButton-startIcon": {
            marginRight: { xs: 1, sm: 1.5 },
            "& svg": {
                fontSize: { xs: 20, sm: 22 },
            },
        },
    });

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: { xs: 1.5, sm: 2 },
            }}
        >
            <Button
                variant="outlined"
                onClick={() => onTipoAnalisisChange(0)}
                startIcon={<TableChart />}
                sx={buttonSx(tipoAnalisisSel === 0)}
            >
                Tablas Detalladas
            </Button>
            <Button
                variant="outlined"
                onClick={() => onTipoAnalisisChange(1)}
                startIcon={<Assessment />}
                sx={buttonSx(tipoAnalisisSel === 1)}
            >
                Resúmenes Estadísticos
            </Button>
        </Box>
    );
}
